import { Component, Vue } from 'vue-property-decorator'
import { getCustomerConversionByMarketClueId } from '@/api/market'

@Component({})
export default class MarketClueCustomerInfo extends Vue {
    infoData = {}
    tableData = []
    id: number
    loading = false

    created() {
        this.id = Number(this.$route.query.id)
        this.getData()
    }

    async getData() {
        this.loading = true
        await getCustomerConversionByMarketClueId(this.id).then((data: any) => {
            this.infoData = data.customerConversion
            this.tableData = data.customerConversion.customerConversionFollowList
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }
}